// Sweetalert mixin
const SwalBootstrap = Swal.mixin({
    buttonsStyling: false,
    scrollbarPadding: false,
    customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-muted',
    },
});

// Set data attribute of element
$.fn.setDataAttribute = function (key, value) {
    $(this).data(key, value).attr('data-' + key, value);

    return $(this);
}

// String slugify
String.prototype.slugify = function () {
    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')

    return this.toString().toLowerCase()
        .replace(/\s+/g, '-')
        .replace(p, c => b.charAt(a.indexOf(c)))
        .replace(/&/g, '-and-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
}

// String match wildcard selectors
String.prototype.wildcardMatch = function (rule) {
    const s = this;
    const regex = (s) => s.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");

    return new RegExp('^' + rule.split('*').map(regex).join('.*') + '$').test(s);
}

// Filter object properties through callback
Object.filter = function (object, predicate) {
    return Object.keys(object)
        .filter(key => predicate(object[key]))
        .reduce((resource, key) => (resource[key] = object[key], resource), {});
}

// Show the default loader box
$.showLoader = function () {
    SwalBootstrap.fire({
        allowEnterKey: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        html: `<div class="loader">
            <div class="shadow"></div>
            <div class="box"></div>
        </div>`,
    });
}

// Smooth scroll to specific position
$.scrollTo = function (position, target = 'html, body', duration = 0) {
    $(target).animate({
        scrollTop: position,
    }, duration);
}

// Redirect or reload to specific page
$.redirectTo = function (url) {
    window.location.href = url;
    if (/(^|\B)#(?![0-9_]+\b)([a-zA-Z0-9_]{1,})(\b|\r)/.test(url)) {
        window.location.reload();
    }
}

// Popup new window with settings
$.popupTo = function (url, title) {
    var width = 1024;
    var height = 768;
    var left = (screen.width / 2) - (width / 2);
    var top = (screen.height / 2) - (height / 2);

    window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, resizable=no, copyhistory=no, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
}

// Generate UUIDv4
$.uuidv4 = function () {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

// Initialize download process
$.initDownload = function (route, interval = 500) {
    $.showLoader();
    var processId = Math.random().toString(36).substring(7),
        url = new URL(route),
        params = new URLSearchParams(url.search);

    params.set('processId', processId);
    window.location.href = url.origin + url.pathname + '?' + params.toString();

    var interval = setInterval(() => {
        $.ajax({
            type: 'POST',
            url: url.origin + url.pathname + '/status',
            beforeSend: function () {
            }, success: function (e) {
                if (e.data.lastProcessed == processId) {
                    $.handleSuccess(e);
                    clearInterval(interval);
                }
            }, error: function (e) {
                $.handleError(e);
            },
        });
    }, interval);
}

// Sleep timeout
$.sleep = function (duration) {
    return new Promise(resolve => setTimeout(resolve, duration));
}

// Get plugins' values
$.getPluginValue = async function (input, plugin) {
    while (!input.data(plugin) || input.data(plugin).initialized === false) {
        await $.sleep(250);
        console.log('waiting', !input.data(plugin));
    }

    switch (plugin) {
        default:
            return input.data(plugin).val();
    }
}

// Set plugins' values
$.setPluginValue = async function (input, plugin, value) {
    while (!input.data(plugin) || input.data(plugin).initialized === false) {
        await $.sleep(250);
        console.log('waiting', !input.data(plugin));
    }

    switch (plugin) {
        case 'daterangepicker':
            input.data(plugin).setStartDate(value);
            input.data(plugin).setEndDate(value);
            break;

        default:
            input.data(plugin).val(value);
    }
}

// Reset input values
$.resetInputValues = function (element, selectors) {
    $(element).find(selectors).not('.ignore').each((index, input) => {
        if (!$(input).parents('.collection').length || ($(input).parents('.collection').length && $(input).parent().closest('.collection').is($(parent)))) {
            // Collections
            if ($(input).data('customCollection')) {
                $(input).data('customCollection').val([]);
            }

            // Selection
            else if ($(input).data('customSelection')) {
                $(input).data('customSelection').val('');
            }

            // Badge inputs
            else if ($(input).data('customBadgeInput')) {
                $(input).data('customBadgeInput').val([]);
            }

            // Phone inputs
            else if ($(input).data('customPhoneInput')) {
                var phoneInput = $(input).data('customPhoneInput');
                if (phoneInput.isNotEmpty()) {
                    phoneInput.val('');
                }
            }

            // Rating inputs
            else if ($(input).data('customRatingInput')) {
                $(input).data('customRatingInput').val(0);
            }

            // Checkboxes & radios
            else if ($(input).is(':checkbox, :radio')) {
                $(input).prop('checked', false);
            }

            // Others
            else {
                $(input).val('');
            }

            $(input).trigger('change');
        }
    });
}

// Get input values
$.getInputValues = function (element, selectors, parent = null) {
    var object = {};

    $(element).find(selectors).not('.ignore').each((index, input) => {
        if (!$(input).parents('.collection').length || ($(input).parents('.collection').length && $(input).parent().closest('.collection').is($(parent)))) {
            // Collections
            if ($(input).data('customCollection')) {
                object[$(input).attr('name')] = $(input).data('customCollection').val();
            }

            // Selection
            else if ($(input).data('customSelection')) {
                object[$(input).attr('name')] = $(input).data('customSelection').val();
            }

            // Badge inputs
            else if ($(input).data('customBadgeInput')) {
                object[$(input).find('ul').attr('name')] = $(input).data('customBadgeInput').val();
            }

            // Phone inputs
            else if ($(input).data('customPhoneInput')) {
                var phoneInput = $(input).data('customPhoneInput');
                if (phoneInput.isNotEmpty()) {
                    object[phoneInput.$input.attr('name')] = phoneInput.val();
                }
            }

            // Rating inputs
            else if ($(input).data('customRatingInput')) {
                if ($(input).data('customRatingInput').val() > 0) {
                    object[$(input).attr('name')] = $(input).data('customRatingInput').val().toString();
                }
            }

            // Tree inputs
            else if ($(input).hasClass('input-tree')) {
                var node = $.ui.fancytree.getTree($(input)).getActiveNode();
                if (node) {
                    object[$(input).attr('name')] = node['key'];
                }
            }

            // Checkboxes & radios
            else if ($(input).is(':checkbox, :radio')) {
                if ($(input).parents('.input-group').length) {
                    object[$(input).closest('.input-group').attr('name')] = $(input).closest('.input-group').find(':checkbox:checked, :radio:checked').map((index, input) => $(input).attr('name')).toArray();
                } else {
                    object[$(input).attr('name')] = $(input).prop('checked');
                }
            }

            // Others
            else {
                object[$(input).attr('name')] = $(input).val();
            }
        }
    });

    return object;
}

// Set input values
$.setInputValues = function (element, selectors, values) {
    for (var i = 0; i < $(element).find(selectors).not('.ignore').length; i++) {
        var input = $(element).find(selectors).not('.ignore')[i],
            attribute = $(input).attr('name'),
            value = values[attribute];

        if ((!$(input).parents('.collection').length || $(element).hasClass('item'))) {
            // Collections
            if ($(input).hasClass('collection') && value) {
                $.setPluginValue($(input), 'customCollection', value);
            }

            // Selection
            else if ($(input).hasClass('selection') && value) {
                $.setPluginValue($(input), 'customSelection', value);
            }

            // Badge inputs
            else if ($(input).hasClass('input-badge') && value) {
                $.setPluginValue($(input), 'customBadgeInput', value);
            }

            // Phone inputs
            else if ($(input).hasClass('input-phone') && value) {
                $.setPluginValue($(input), 'customPhoneInput', value);
            }

            // Daterangepickers
            else if ($(input).hasClass('date-range') && value) {
                $.setPluginValue($(input), 'daterangepicker', value);
            }

            // Checkboxes & radios
            else if ($(input).is(':checkbox, :radio')) {
                if ($(input).parents('.input-group').length) {
                    values[$(input).closest('.input-group').attr('name')].forEach(value => {
                        $(input).closest('.input-group').find(`[name="${value}"]`).prop('checked', true);
                    });
                } else {
                    $(input).prop('checked', value);
                }
            }

            // Others
            else {
                $(input).val(value);
            }

            $(input).trigger('change');
        }
    }
}

// Parse currency format
$.formatNumber = function (amount, decimal = 2) {
    amount = parseFloat(amount);
    if (!isNaN(amount)) {
        return amount.toFixed(decimal).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
}

// Focus input based on event errors
$.focusOnError = function (e) {
    if (e.responseJSON.errors !== undefined) {
        $('input[name*="password"]').val('');
        $('[name="' + Object.keys(e.responseJSON.errors)[0] + '"]').trigger('focus');
    }
}

// Handle HTTP success responses
$.handleSuccess = function (e, onClose = () => { }) {
    SwalBootstrap.fire({
        didClose: onClose,
        icon: 'success',
        showConfirmButton: false,
        text: e.data.message,
        timer: 2000,
        title: 'Success.',
    });
}

// Handle HTTP error responses
$.handleError = function (e, onClose = () => { }) {
    switch (e.status) {
        case 500:
            SwalBootstrap.fire({
                icon: 'error',
                text: 'We have encountered an unexpected error. Kindly contact the site developer for more details.',
                title: 'Unexpected Error.',
                didClose: () => {
                    window.location.reload();
                },
            });
            break;
        case 403:
            SwalBootstrap.fire({
                icon: 'error',
                text: 'Your action is unauthorized. Kindly try again using the correct account with the relevant privilege.',
                title: 'Unauthorized Action.',
                didClose: onClose,
            });
            break;
        case 422:
            SwalBootstrap.fire({
                icon: 'error',
                text: e.responseJSON.errors[Object.keys(e.responseJSON.errors)[0]][0],
                title: e.responseJSON.message,
                didClose: onClose,
            });
            break;
        case 400:
        case 401:
        default:
            SwalBootstrap.fire({
                icon: 'error',
                text: e.responseJSON.message,
                title: 'Error.',
                didClose: onClose,
            });
    }
}

// Prompt Confirmation
$.promptConfirmation = function (message, onConfirm = () => { }, onCancel = () => { }) {
    SwalBootstrap.fire({
        confirmButtonText: 'Confirm',
        icon: 'warning',
        showCancelButton: true,
        text: message,
        title: 'Confirmation',
    }).then((result) => {
        result.value ? onConfirm() : onCancel();
    });
}

// Initiate Progress
$.initiateProgress = function () {
    $('.progress.circle').each(function () {
        var value = $(this).data('progress');
        var left = $(this).find('.progress-left .progress-bar');
        var right = $(this).find('.progress-right .progress-bar');

        if (value > 0) {
            if (value <= 50) {
                right.css('transform', 'rotate(' + (value / 100 * 360) + 'deg)');
            } else {
                right.css('transform', 'rotate(180deg)');
                left.css('transform', 'rotate(' + ((value - 50) / 100 * 360) + 'deg)');
            }
        }
    });

    $('.progress.bar').each(function () {
        $(this).find('.progress-bar').css('width', $(this).data('progress') + '%');
    });
}

// Set Cookies
$.setCookie = function (cname, cvalue, exdays = 365) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

// Get Cookies
$.getCookie = function (cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }

    return '';
}
